<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
  campaignReport: {
    type: Object,
    default: null,
  },
});

const showModal = ref(false);
const { t } = useI18n();
</script>

<template>
  <div>
    <div class="flex items-center gap-2">
      <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
        {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
      </span>
      <div class="flex items-center gap-1.5 flex-shrink-0">
        <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
        <span class="text-sm font-medium text-n-slate-12">
          {{ inboxName }}
        </span>
      </div>

      <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
        {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
      </span>
      <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
        {{ messageStamp(new Date(scheduledAt), 'LLL d, h:mm a') }}
      </span>
    </div>
    <div
      v-if="campaignReport && Object.keys(campaignReport).length > 0"
      class="flex items-center gap-2 mt-2"
    >
      <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
        {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.REPORT') }}
      </span>
      <div class="flex items-center gap-1.5 flex-shrink-0">
        <span
          v-tooltip.top="
            $t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.TOOLTIPS.SENT')
          "
          class="i-lucide-check"
        />
        {{ campaignReport.status_counts?.sent || 0 }}
      </div>
      <div class="flex items-center gap-1.5 flex-shrink-0">
        <span
          v-tooltip.top="
            $t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.TOOLTIPS.DELIVERED')
          "
          class="i-lucide-check-check"
        />
        {{ campaignReport.status_counts?.delivered || 0 }}
      </div>
      <div class="flex items-center gap-1.5 flex-shrink-0">
        <span
          v-tooltip.top="
            $t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.TOOLTIPS.READ')
          "
          class="i-lucide-check-check text-[#7EB6FF]"
        />
        {{ campaignReport.status_counts?.read || 0 }}
      </div>
      <div class="flex items-center gap-1.5 flex-shrink-0">
        <span
          v-tooltip.top="
            $t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.TOOLTIPS.FAILED')
          "
          class="i-lucide-circle-x text-red cursor-pointer"
          @click="showModal = true"
        />
        {{ campaignReport.status_counts?.failed || 0 }}
      </div>
      <div>
        {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.GENERATED_AT') }}
        <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
          {{
            messageStamp(
              Math.floor(
                new Date(campaignReport.generated_at).getTime() / 1000
              ),
              'LLL d, h:mm a'
            )
          }}
        </span>
      </div>
    </div>
  </div>
  <woot-modal v-model:show="showModal">
    <div
      class="text-xs font-medium text-n-slate-11 flex items-center gap-1 m-2"
    >
      <span>{{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.REPORT') }}</span>
    </div>

    <table class="w-full border border-n-slate-7 my-2 text-sm">
      <thead>
        <tr class="bg-n-slate-2">
          <th
            class="text-left p-2 border border-n-slate-7 text-xs font-medium text-n-slate-11"
          >
            {{ t('CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.TABLE.HEADER.TO') }}
          </th>
          <th
            class="text-left p-2 border border-n-slate-7 text-xs font-medium text-n-slate-11"
          >
            {{
              t(
                'CAMPAIGN.WHATSAPP.CARD.CAMPAIGN_DETAILS.TABLE.HEADER.ERROR_MESSAGE'
              )
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="failure in campaignReport.failures"
          :key="failure.message_id"
          class="hover:bg-n-slate-2 transition"
        >
          <td class="p-2 border border-n-slate-7 text-n-slate-12">
            {{ failure.to }}
          </td>
          <td class="p-2 border border-n-slate-7 text-n-slate-12">
            {{ failure.error_message }}
          </td>
        </tr>
      </tbody>
    </table>
  </woot-modal>
</template>
